import { action, computed, observable } from 'mobx';

const storage = localStorage;
const ACCESS_TOKEN = 'accessToken';
const USER_NAME = 'userName';

export class Auth {
  @observable accessor accessToken = storage.getItem(ACCESS_TOKEN) || '';
  @observable accessor userName = storage.getItem(USER_NAME) || '';

  @action
  setToken(token: string) {
    try {
      storage.setItem(ACCESS_TOKEN, token);
    } finally {
      this.accessToken = token;
    }
  }

  @action
  getToken() {
    return this.accessToken;
  }

  @action
  setUserName(name: string) {
    try {
      storage.setItem(USER_NAME, name);
    } finally {
      this.userName = name;
    }
  }

  @action
  getUserName() {
    return this.userName;
  }

  @action
  logout() {
    this.accessToken = '';
    this.userName = '';
    storage.removeItem(ACCESS_TOKEN);
    storage.removeItem(USER_NAME);
  }

  @computed
  get loggedIn(): boolean {
    return !!this.accessToken;
  }
}

export default new Auth();
